import { network } from 'services/network';

export const resetPassword = (params) => {
    return network.post('admin/bo/resetPassword', params).then(() => {
        return true;
    });
};
